import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useMessage } from '@tmapy/intl';

import { BtnBar, Form, FormItem, SecondaryBtn, CtaBtn, Textarea } from '@tmapy/style-guide';

import type { InputProps } from '../../hooks/useInput';
import { useInput } from '../../hooks';
import { orderApprovalMessages as msg } from './orderMessages';

type RejectionDialogProps = {
  confirmRejected: Function;
  closeRejectionDialog: Function;
};

export const RejectionDialog: React.FC<RejectionDialogProps> = (props) => {
  const formatMessage = useMessage();

  const [isConfirmedBtnClicked, setConfirmedBtnClicked] = useState(false);

  const handleRejectionFormConfirm = () => {
    setConfirmedBtnClicked(true);
    if (rejectionReason.value) {
      props.confirmRejected(rejectionReason.value);
    }
  };

  const handleDialogClose = () => {
    setConfirmedBtnClicked(false);
    props.closeRejectionDialog();
  };

  const rejectionReason = useInput<InputProps>({
    name: 'rejection_reason',
    initialValue: '',
    label: formatMessage(msg.orderRejectionReason),
    validate: isConfirmedBtnClicked,
    validator: (value) => (!value ? formatMessage(msg.orderApprovalReasonError) : null),
  });

  return (
    <Form onSubmit={handleRejectionFormConfirm}>
      <div className='sg-a-p-4 sg-u-vs-2'>
        <FormItem {...rejectionReason} isRequired>
          <Textarea {...rejectionReason} />
        </FormItem>

        <BtnBar>
          <CtaBtn type='submit'>
            <FormattedMessage {...msg.orderRejectBtn} />
          </CtaBtn>
          <SecondaryBtn isDanger onClick={handleDialogClose}>
            <FormattedMessage {...msg.orderApprovalCloseDialogBtn} />
          </SecondaryBtn>
        </BtnBar>
      </div>
    </Form>
  );
};
